import React, {useState, useEffect} from "react"
import {Col, Collapse, Pagination, PaginationItem, PaginationLink, Row} from 'reactstrap'
import { customStyles } from "helpers/component_helpers";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import Card from "components/PurpleTheme/Card";

import { getUsers, getRca } from "store/actions";

import RcaItemList from "./RcaItemList";
import RcaActionItemsList from "./RcaActionItemsList";
const selectUsers = state => state.Organization.users || [];
const selectRcas = state => state.Rca.rcas;

const RcaItemsCard = ({currentTab}) => {
  const dispatch = useDispatch();
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [ allUsers, setAllUsers ] = useState({});
  const [searchQueryUser, setSearchQueryUser] = useState(null);
  const [searchQueryReviewer, setSearchQueryReviewer] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredResources, setFilteredResources] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [currentTabState, setCurrentTabState] = useState(currentTab);


  const [filters, setFilters] = useState({
    status: null,
    owner: null,
    name: null,
    date_created: null,
    start_date: null,
    end_date: null,
    reviewer: null});
  const [ actionItemsCount, setActionItemsCount ] = useState({total: 0, completed:0})


  const usersState = useSelector(selectUsers);
  const rcas = useSelector(selectRcas);
  const [clrFilters, setClrFilters] = useState(false);
  const toggle = () => {
    setFiltersOpen(!filtersOpen);
    setClrFilters(clrFilters => !clrFilters);
  }
  const [filteredRcas, setFilteredRcas] = useState(rcas?.rca);
  const [total_resources_count, setTotal_resources_count] = useState(0);
  useEffect(() => {
    if(currentTab === "RCA") {
      setTotal_resources_count(rcas?.rcas_count || 0);
    } else if (currentTab === "Action Items") {
      setTotal_resources_count(rcas?.action_items_count || 0);
    }
  }, [currentTab,getRca,rcas]);
  const itemsPerPage =  50;
  const [selectedPage, setSelectedPage] = useState(1);
  const totalPages = Math.ceil(total_resources_count / itemsPerPage) || 0;
  let startPage = Math.max(selectedPage - 1, 1);
  let endPage = Math.min(startPage + 2, totalPages);
  if (endPage === totalPages) {
    startPage = Math.max(totalPages - 2, 1);
  }
  let pageFilters = {}
  const handlePageClick = (pageNumber) => {
    setIsLoading(true);
    if (pageNumber < 1) {
      setIsLoading(false);
      return;
    }

    if (selectedPage < pageNumber && filteredResources.length < itemsPerPage) {
      setIsLoading(false);
      return;
    }

    setSelectedPage(pageNumber);
    endDate ? formatDate(endDate) : '';
    pageFilters['page'] = pageNumber;
    pageFilters['limit'] = itemsPerPage;
    pageFilters['search_item'] = filters?.name;
    pageFilters['start_date'] = filters?.start_date;
    pageFilters['status'] = filters?.status?.value;
    pageFilters['end_date'] = filters?.end_date;
    pageFilters['date_created'] = filters?.date_created;
    pageFilters['owner'] = filters?.owner?.id;
    pageFilters['reviewer']= filters?.reviewer?.id;
    pageFilters['filter_type'] = currentTab;
    dispatch(getRca(pageFilters));
    setSelectedPage(pageNumber);
  };

  useEffect(() => {
    setFilteredRcas(rcas?.rca || []);
  },[rcas])

  function formatDate(dates) {
    const date = new Date(dates);
    const utcDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    return utcDate.toUTCString();
  }

  const statusOptions = [
    { value: "Open", label: "Open" },
    { value: "Closed", label: "Closed"},
    { value: "ShortTermFixPending", label: "ShortTermFixPending"},
    { value: "LongTermFixPending", label: "LongTermFixPending"}
  ]

  const ActionItemsStatusOptions = [
    { value: "Pending", label: "Pending" },
    { value: "InProgess", label: "In Progress"},
    { value: "Completed", label: "Completed"},
  ]

  const userOptions = Object.entries(allUsers).map(([key, value]) => ({
    value: key,
    label: value.name,
    user: value
  }));

  useEffect(() => {
    let pageFilters = {
      'page': 1,
      'limit': itemsPerPage,
      'filter_type':"RCA"
    }
    dispatch(getRca(pageFilters))
    dispatch(getUsers())
  }, [getRca, getUsers, dispatch,currentTab]);

  useEffect(() => {
    clearFilters()
    setSelectedPage(1)
  }, [currentTab])

  useEffect(() =>{
    if (currentTab === "RCA"){
      setFilteredResources(rcas?.rca || []);
    }else if (currentTab === "Action Items"){
      setFilteredResources(rcas?.action_items || []);
    }
  },[getRca,dispatch, rcas,currentTab])

  useEffect(() => {
    const updatedUsers = {};
    const users = usersState
    setTimeout(() => {
      users?.forEach((item) => {
        updatedUsers[item.id] = {
          id: item.id,
          name: item.name,
          profile_picture_url: item.profile_picture_url,
          email: item.email
        };
      });
      setAllUsers(updatedUsers);
    }, 10)
  }, [usersState, rcas]);

  useEffect(() => {
    const actionItems = [...(rcas?.action_items || [])];

    let total_action_items = 0;
    let completed_action_items = 0;
    actionItems.forEach((item) => {
      total_action_items+=1;
      if(item.status === "Done"){
        completed_action_items += 1
      }
    })
    setActionItemsCount({
      total: total_action_items,
      completed: completed_action_items
    })
  }, [rcas])

  const filteredRcas_const = filteredRcas?.filter((rca) => {
    return !filters.name || rca?.rca?.title?.toLowerCase().includes(filters.name.toLowerCase());
  })

  const filteredActionItems = rcas.action_items?.filter((actionItem) => {
    return !filters.name || actionItem?.title?.toLowerCase().includes(filters.name.toLowerCase());
  });

  const clearFilters = () => {
    setFilters({
      status: null,
      owner: null,
      name: null,
      date_created: null,
      start_date: null,
      end_date: null,
      reviewer: null
    });
    setSearchQueryUser('');
  };


  return(
      <React.Fragment>
        <Card>
          <div className="d-flex align-items-center justify-content-start flex-wrap mb-3">
            <div className="me-2 col-3 mb-1">
              <Col md="11">
                <input
                    className="searchbar"
                    style={{width: "100%", height: "40px"}}
                    placeholder="Search: name"
                    value={filters.name || ''}
                    onChange={(e) => setFilters({...filters, name: e.target.value})}
                />
              </Col>
            </div>
            <div className="me-2 mb-1">
              <Col md="auto">
                <a href="#" onClick={toggle} className="btn btn-secondary">
                  <i className="bx bx-filter-alt align-middle"></i> Advanced Filter
                </a>
              </Col>
            </div>
            <div className="me-2 mb-1 mx-3">
              <Col md="auto">
                {clrFilters === false ?
                    null
                    :
                    <button onClick={clearFilters} className="btn btn-secondary">
                      Clear Filters
                    </button>}
              </Col>
            </div>
            <div className="ms-auto">
              <Col md="auto">
                <Pagination aria-label="pagination navigation" listClassName="justify-content-end pagination-rounded" className="mb-3">
                  {totalPages > 1 && (
                      <PaginationItem disabled={selectedPage === 1}>
                        <PaginationLink previous onClick={() => {handlePageClick(selectedPage - 1)}} />
                      </PaginationItem>
                  )}
                  {[...Array(endPage - startPage + 1)].map((_, index) => (
                      <PaginationItem key={startPage + index} active={selectedPage === startPage + index}>
                        <PaginationLink onClick={() => {handlePageClick(startPage + index)}}>
                          {startPage + index}
                        </PaginationLink>
                      </PaginationItem>
                  ))}
                  {totalPages > 1 && (
                      <PaginationItem disabled={selectedPage === totalPages}>
                        <PaginationLink next onClick={() => {handlePageClick(selectedPage + 1)}} />
                      </PaginationItem>
                  )}
                </Pagination>
              </Col>
            </div>
          </div>

          <Collapse isOpen={filtersOpen}>
            <div className="d-flex flex-column gap-4 mt-5">
              <div className="d-flex gap-3">
                <div style={{width: "20%"}}>
                  <Select
                      isClearable
                      value={filters.status}
                      options={currentTab === "RCA" ? statusOptions : ActionItemsStatusOptions}
                      onChange={(selectedOption) => {
                        setClrFilters(clrFilters);
                        if (selectedOption) {
                          setFilters({
                            ...filters,
                            status: selectedOption,
                          })
                        } else {
                          setFilters({
                            ...filters,
                            status: null,
                          });
                        }
                      }}
                      placeholder="Status"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          neutral0: '#222736',
                          neutral5: '#485EC4',
                          neutral10: '#485EC4',
                          neutral60: '#ffffff',
                          neutral70: '#ffffff',
                          neutral80: '#ffffff',
                          neutral90: '#ffffff',
                          primary: '#485EC4',
                        },
                      })}
                      styles={customStyles}
                  />
                </div>
                <div style={{width: "25%"}}>
                  <Select
                      isClearable
                      value={filters.owner ? {
                        value: filters.owner.id,
                        label: filters.owner.name,
                        user: filters.owner
                      } : null}
                      options={userOptions}
                      onChange={(selectedOption) => {
                        setFilters({
                          ...filters,
                          owner: selectedOption ? selectedOption.user : null
                        });
                      }}
                      placeholder="Search: Owner"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          neutral0: '#222736',
                          neutral5: '#485EC4',
                          neutral10: '#485EC4',
                          neutral60: '#ffffff',
                          neutral70: '#ffffff',
                          neutral80: '#ffffff',
                          neutral90: '#ffffff',
                          primary: '#485EC4',
                        },
                      })}
                      styles={customStyles}
                  />
                </div>
                <div style={{width: "25%"}}>
                  <Select
                      isClearable
                      value={filters.reviewer ? {
                        value: filters.reviewer.id,
                        label: filters.reviewer.name,
                        user: filters.reviewer
                      } : null}
                      options={userOptions}
                      onChange={(selectedOption) => {
                        setFilters({
                          ...filters,
                          reviewer: selectedOption ? selectedOption.user : null
                        });
                      }}
                      placeholder="Search: Reviewer"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                          ...theme.colors,
                          neutral0: '#222736',
                          neutral5: '#485EC4',
                          neutral10: '#485EC4',
                          neutral60: '#ffffff',
                          neutral70: '#ffffff',
                          neutral80: '#ffffff',
                          neutral90: '#ffffff',
                          primary: '#485EC4',
                        },
                      })}
                      styles={customStyles}
                  />
                </div>
              </div>

              <div className="d-flex flex-column gap-3">
                <div className="mb-3">
                  <button type="button" className="btn btn-primary w-md" onClick={() => handlePageClick(1)}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
          {currentTab === "RCA" ?
              <RcaItemList
                  data={filteredRcas_const || []}
                  total_action_items={actionItemsCount.total}
                  completed_action_items={actionItemsCount.completed}
                  all_users={allUsers}
              />
              :
              currentTab === "Action Items" ?
                  <RcaActionItemsList
                      data={filteredActionItems || []}
                      all_users={allUsers}
                  />
                  :
                  null
          }
        </Card>
      </React.Fragment>
  )
}

export default RcaItemsCard;